// Exact per-shift labor value across an order, used for
// `order_submitted.total_value`. Both V1 and V2 adapt their own job shape into
// `ValueJob[]` and call this so the two flows agree to the cent.
// `quantity` is the number of workers on the shift. total_value is labor
// value, so each shift contributes pay × net hours × workers — a shift staffed
// by 3 workers is worth 3× a single-worker shift of the same length.
export type ValueShift = {
  grossMinutes: number;
  breakMinutes: number;
  quantity: number;
};
export type ValueJob = { payRateDollars: number; shifts: ValueShift[] };

export function computeOrderTotalValue(jobs: ValueJob[]): number {
  const total = jobs.reduce(
    (jt, job) =>
      jt +
      job.shifts.reduce(
        (st, s) =>
          st +
          job.payRateDollars *
            Math.max(0, (s.grossMinutes - s.breakMinutes) / 60) *
            Math.max(0, s.quantity),
        0,
      ),
    0,
  );
  return Math.round(total * 100) / 100;
}
